import React from 'react'
import styled from 'styled-components'

// A PureComponent
const Icon = React.memo<{
    icon: string
    alt: string
}>(({ icon, alt }) => {
    return <IconImage src={icon} alt={alt} />
})

export default Icon

const IconImage = styled.img`
    max-width: 50vh;
    max-height: 30vh;
    margin: 0 auto;

    @media (orientation: portrait) {
        max-width: 30vh;
        max-height: 50vh;
    }
`
